// @core/api/endpoints/affiliate/pause_campaign.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CampaignResponse,
  PauseCampaignRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Pause campaign
 * Performs pause operation on campaign.
 */
export async function PauseCampaign(
  campaign_id: string,
  data: PauseCampaignRequest,
  options?: RequestOptions
): Promise<CampaignResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/campaigns/:campaign_id/pause`;
  requestPath = requestPath.replace(':campaign_id', encodeURIComponent(campaign_id));
  const requestOptions = options;
  return client.post<CampaignResponse>(requestPath, data, requestOptions);
}
